import React from "react";
//#region types
import { ActionLinkButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import StyledButton from "./styledButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ActionLinkButton: React.FC<ActionLinkButtonProps> = (props) => {
  return (
    <StyledButton {...props} className={clsx(cssExports.actionLinkButton, props.className)} testId={props.testId}>
      {props.children}
    </StyledButton>
  );
};

export default ActionLinkButton;
